import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchLargePhoto: `${NAMESPACE}_PHOTO_GALLERY_FETCH_LARGE_PHOTO`,
  fetchLargePhotoSucceeded: `${NAMESPACE}_PHOTO_GALLERY_FETCH_LARGE_PHOTO_SUCCEEDED`,
  fetchLargePhotoFailed: `${NAMESPACE}_PHOTO_GALLERY_FETCH_LARGE_PHOTO_FAILED`,
  setCurrentPhotoId: `${NAMESPACE}_PHOTO_GALLERY_SET_CURRENT_PHOTO_ID`,
  resetState: `${NAMESPACE}_PHOTO_GALLERY_RESET_STATE`
};

export const actionCreators = {
  fetchLargePhoto: (photoId) => ({ type: actions.fetchLargePhoto, payload: photoId }),
  fetchLargePhotoSucceeded: (data) => ({ type: actions.fetchLargePhotoSucceeded, payload: data }),
  fetchLargePhotoFailed: (error) => ({ type: actions.fetchLargePhotoFailed, payload: error }),
  setCurrentPhotoId: (photoId) => ({ type: actions.setCurrentPhotoId, payload: photoId }),
  resetState: () => ({ type: actions.resetState })
};

export default {
  actions,
  actionCreators
};
